export default __webpack_public_path__ + "static/media/media-01.ad88e817.jpg";